"use client";
import React from 'react';

const ArticleFilter = ({ filterValue, setFilterValue }) => {
  return (
    <div className="recent-blogs-filter-wrapper-bp">
      <select 
        className="recent-blogs-filter-bp"
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
      >
        <option value="All">All</option>
        <option value="Investment">Investment</option>
        <option value="Market Trends">Market Trends</option>
        <option value="Expert Insights">Expert Insights</option>
      </select>
    </div>
  );
};

export default ArticleFilter;

